import { ReactNode } from 'react';
import './BordTable.scss';

interface BordTableProps {
  headers: string[] | ReactNode[];
  data: any[][];
}

const BordTable = ({ headers, data, ...rest }: React.HTMLAttributes<HTMLElement> & BordTableProps) => {
  return (
    <table {...rest} className={`bordTable ${rest.className || ''}`}>
      <thead className="bordTable__header">
        <tr>
          {headers?.map((header, index) => (
            <th key={index}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data?.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <td key={cellIndex}>{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default BordTable;
